import {
    ChangeDetectionStrategy,
    Component,
    Injectable,
    Input,
} from '@angular/core';
import {
    IQueueItem,
    ODataResponse,
} from '@models';
import {
    GRID_SERVICE,
    IGridSource,
    ODataGridComponent,
} from '@pages/generics/grid';
import {
    ODataQueryOptions,
    QueueItemService,
} from '@services';

@Injectable()
export class TransactionAttemptSource implements IGridSource<ODataQueryOptions, ODataResponse<IQueueItem>> {
    public queueItemId!: number;

    public get mapper() {
        return this._queueItems.mapper;
    }

    constructor(
        private _queueItems: QueueItemService,
    ) { }

    public get(qo: ODataQueryOptions) {
        return this._queueItems.getQueueItemHistory(this.queueItemId, qo);
    }
}

@Component({
    selector: 'ui-transaction-attempts',
    templateUrl: './transaction-attempts.grid.html',
    providers: [
        TransactionAttemptSource,
        {
            provide: GRID_SERVICE,
            useClass: TransactionAttemptSource,
            deps: [QueueItemService],
        },
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TransactionAttemptsGridComponent extends ODataGridComponent<IQueueItem, number> {
    @Input()
    public set queueItem(value: IQueueItem) {
        const svc = (this._service as TransactionAttemptSource);
        if (
            !svc ||
            !value ||
            svc.queueItemId === value.id
        ) { return; }

        svc.queueItemId = value.id;
        this._refresh$.next();
    }
}
